import { ofType } from "redux-observable";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionQuestInfo } from "../../info/quest/actionQuestInfo";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { checkTutorialQuestClickComplete } from "../checks/checkTutorialQuestClickComplete";
import { pathTutorialUpdate } from "../path/pathTutorialUpdate";
export var epicTutorialQuestCompleteClick = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuestInfo.Finish), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialQuestClickComplete])(pathTutorialUpdate),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialQuestCompleteClick.ts
// module id = 2494
// module chunks = 3